import { makeStyles, Step, StepLabel, Stepper } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    fontFamily: 'Montserrat',
    fontWeight: 'bold',
    borderBottom: '2px solid #d4d4d4',
  },
})

export default function StepsProgress({
  stepNames,
  activeStepIndex,
}: {
  stepNames: string[]
  activeStepIndex: number
}): JSX.Element {
  const classes = useStyles()
  return (
    <Stepper
      alternativeLabel
      activeStep={activeStepIndex}
      className={classes.root}
    >
      {stepNames.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
